import MenuAim from 'menu-aim';

const Menu = function () {
  let menuLoaded = false;
  const selectors = {
    mainMenuWrap: '.rnk-row-mega-menu',
    mainMenu: '.rnk-row-mega-menu .menu-drop',
  };
  let $menuDrop;

  /**
   * Atualizar link de login no menu principal
   *
   * @returns void
   */
  const fixLoginLinkMenu = () => {
    if (!$menuDrop) {
      return;
    }

    const $linkLogin = $menuDrop.find('.btn-login-menu a');
    if (window.storeTheme?.user?.isAuthenticated) {
      $linkLogin.removeClass('open-modal-login').addClass('logout').html('Sair');
    } else {
      $linkLogin.html('Login');
    }
  };

  const isMobile = () => {
    return !$('.rnk-container-menu ul.rnk-componente-menu').is(':visible');
  };

  $(window).on('user.storeTheme', fixLoginLinkMenu);

  const initMenu = () => {
    menuLoaded = true;
    $('script#template-menu-drop').replaceWith($('script#template-menu-drop').html());
    $menuDrop = $('.menu-drop');
    fixLoginLinkMenu();
    const menuAinOptions = {
      menuItemSelector: '.prod-menu-item',
      menuItemActiveClassName: 'target_item',
      menuItemSubMenuSelector: '.prod-submenu',
      delayingClassName: 'target_delaying',
    };

    MenuAim(document.querySelector(selectors.mainMenu), menuAinOptions);

    $('.btn-back').on('click', function (event) {
      if ($(event.target).is('span')) {
        event.preventDefault();
        const $el = $(this);
        $el.closest('.prod-submenu').removeClass('open-menu');
        $('.prod-submenu').closest('.prod-menu-item').removeClass('target_item');
        return;
      }
      window.storeTheme?.helpers?.loader?.topbar?.show();
    });

    $('.prod-menu-link ').on('click', function (event) {
      if (isMobile()) {
        event.preventDefault();
      }
      var $menu_item = $(this).closest('.prod-menu-item');
      $menu_item.closest('.prod-menu').addClass('active_block');
      $menu_item.addClass('target_item');
      $menu_item.find('.prod-submenu').addClass('open-menu');
      setTimeout(() => {
        $('.prod-menu-wrap').scrollTop(0);
      }, 300);
    });

    // open submenu child
    $('.prod-submenu-link').on('click', function (event) {
      const $this = $(event.currentTarget);
      if ($this.attr('href').charAt(0) === '#') {
        event.preventDefault();
      }
      const $el_submenu = $this.closest('.wrap-menu');
      const $cat_submenu = $el_submenu.find('.category-submenu');
      $this.toggleClass('selected');
      $cat_submenu.each(function (index) {
        if ($(this).hasClass('open-accordion')) {
          $(this).removeClass('open-accordion');
        } else {
          $(this).addClass('open-accordion');
        }
      });
    });
  };

  const toggleMenu = () => {
    $menuDrop.toggleClass('show-menu-drop');
    $(selectors.mainMenuWrap)[$menuDrop.hasClass('show-menu-drop') ? 'addClass' : 'removeClass']('widget-show');
  };

  $(document).on('click.megaMenu', (event) => {
    const $this = $(event.target);
    const isTrigger = $this.is('#megamenu-trigger a, .btn-mobile-menu-sw, .rnk-row-mega-menu .btn-close-widget');
    const isParentTrigger = !!$this.closest(
      '#megamenu-trigger a, .btn-mobile-menu-sw, .rnk-row-mega-menu .btn-close-widget',
    ).length;

    if ($this.closest($menuDrop).length && !isTrigger && !isParentTrigger) {
      return;
    }

    if (isTrigger || isParentTrigger) {
      event.preventDefault();
      if (!menuLoaded) {
        initMenu();
      }

      toggleMenu();
      return;
    }

    if (!isParentTrigger && $menuDrop && $menuDrop.hasClass('show-menu-drop')) {
      toggleMenu();
    }
  });
};

Menu();

export default {};
